import * as React from "react";
import styles from "./Empty.module.css";
import { cn } from "../../../utils/cn";

const Empty = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div data-slot="empty" className={cn(styles.empty, className)} {...props} />
  );
};

const EmptyHeader = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      data-slot="empty-header"
      className={cn(styles.header, className)}
      {...props}
    />
  );
};

const EmptyMedia = ({
  className,
  variant = "default",
  ...props
}: React.HTMLAttributes<HTMLDivElement> & {
  variant: "default" | "icon";
}) => {
  return (
    <div
      data-slot="empty-icon"
      data-variant={variant}
      className={cn(styles.media, styles[`media-${variant}`], className)}
      {...props}
    />
  );
};

const EmptyTitle = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      data-slot="empty-title"
      className={cn(styles.title, className)}
      {...props}
    />
  );
};

const EmptyDescription = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      data-slot="empty-description"
      className={cn(styles.description, className)}
      {...props}
    />
  );
};

const EmptyContent = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      data-slot="empty-content"
      className={cn(styles.content, className)}
      {...props}
    />
  );
};

export {
  Empty,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
  EmptyDescription,
  EmptyContent,
};
